import { Colors } from '../../consts/Colors';
export default class Card4 extends Phaser.GameObjects.Container {
    constructor(scene, x, y, cardData, deck, placeholder) {
        super(scene, x, y, []);

        scene.add.existing(this);
        this.initPosition = { x: x, y: y }
        this.scene = scene;
        this.isDone = false;
        this.imgName = cardData.image
        this.zoneId = cardData.zoneId;
        this.zoneType = cardData.zoneType;
        this.initAngle = cardData.angle;
        this.placeholder = placeholder
        this.zoneDropped = undefined
        this.zoneCorrect = undefined
        this.isGood = false
        this.isCorrect = false
        this.isFirstDrop = true

        this.scaleOut = 1
    
        this.deck = deck

        this.cardBackground = this.scene.add.rexRoundRectangle(0, 0, 350, 40, 8, Colors.Elmt.White).setOrigin(0.5);
        this.add(this.cardBackground);
        this.cardImage = this.scene.add.image(0, 0, this.imgName).setOrigin(0.5);
        
        this.add(this.cardImage);

        this.badAnswerLogo = this.scene.add.image(this.cardBackground.width/2 - 10, -this.cardBackground.height/2+10, 'badAnswer3').setOrigin(0.5).setAlpha(0)
        this.add(this.badAnswerLogo)

        this.setSize(this.cardImage.width, this.cardImage.height);
        this.setInteractive({ useHandCursor: true });
        this.scene.input.setDraggable(this)

        this.setAngle(this.initAngle)
        this.setScale(this.scaleOut)
        this.setDepth(5)

        this.on('pointerover', () => {
            this.scene.tweens.add({
            targets: this,
            scale: 1.5,
            duration: 50
        })
        })

        this.on('pointerout', () => {
            this.scene.tweens.add({
            targets: this,
            scale: 1,
            duration: 50
        })
        })
    }

    drop(pointer, gameObject, dropZone) {
        // On modifie la zone
        let currentDroppedCard = dropZone.onDrop(gameObject)
        if(currentDroppedCard !== undefined){
            currentDroppedCard.reset()
        }

        if(gameObject.zoneDropped != undefined){
            gameObject.zoneDropped.reset()
        }

        if(dropZone == undefined) return

        // On valide la carte
        gameObject.setAngle(0)
        gameObject.zoneDropped = dropZone
        gameObject.isDone = true
        gameObject.x = dropZone.x - gameObject.parentContainer.x
        gameObject.y = dropZone.y - gameObject.parentContainer.y
        gameObject.setScale(1)

        // On donne l'info au deck
        gameObject.deck.update()
    }

    dragEnd(pointer, gameObject, dropped) {
        if (!dropped) {
            if(gameObject.zoneDropped != undefined){
                gameObject.zoneDropped.reset()
            }
            gameObject.resetPosition(this.scaleOut)
        }
    }

    onDrag() {
        this.scene.tweens.add({
            targets: this,
            scale: 1,
            duration: 50
        })
    }

    setGood() {
        if (this.isGood === false) {
            this.isGood = true
            
            this.cardImage.setOrigin(0, 0.5)
            this.cardImage.x = -this.cardBackground.width/2 + 10
            this.cardBackground.setAlpha(0)
            this.placeholder.setVisible(false)

        }
    }
    setBad() {
        this.badAnswerLogo.setAlpha(1)
        // this.cardImage.setTexture(this.imgName + "False")
        this.cardBackground.setStrokeStyle(4, Colors.Elmt.Red, 1);
    }

    reset(){
        if(this.isGood){
            this.scene.tweens.add({
                targets: this,
                duration: 300,
                x: this.zoneCorrect.x- this.parentContainer.x,
                y: this.zoneCorrect.y - this.parentContainer.y,
            })
            this.scene.setActionBackground(this.zoneId)

        }else{
            this.cardImage.setTexture(this.imgName)
            this.badAnswerLogo.setAlpha(0)
            this.zoneDropped = undefined
            this.isDone = false
            this.cardBackground.setAlpha(1)
            this.cardBackground.setStrokeStyle(0, Colors.Elmt.White, 0);
            this.resetPosition(this.scaleOut)
        }
    }

    resetPosition(scale = 1, duration = 300 ) {
        this.setAngle(this.initAngle)
        this.scene.tweens.add({
            targets: this,
            duration: duration,
            x: this.initPosition.x,
            y: this.initPosition.y,
            scale: scale,
            onComplete: () => {
                this.setInteractive({ useHandCursor: true })
            }
        })
    }
}